import { GridCoordinates } from "../PlayPanel.logic";

export const gridCoordinatesGet = (area: GridCoordinates): GridCoordinates => {
  const columnStart: number = area.columnStart + 1;
  const columnEnd: number = area.columnEnd + 1;
  const rowStart: number = area.rowStart + 1;
  const rowEnd: number = area.rowEnd + 1;

  const result: GridCoordinates = {
    columnStart,
    columnEnd,
    rowStart,
    rowEnd,
  };

  return result;
};
